// Smooth in-page navigation that works with Lenis (falls back to native).
export const scrollToId = (href) => {
    const el =
        typeof href === "string" ? document.querySelector(href) : href;
    if (!el) return false;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.1 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
    return true;
};
